//PATH
const URL="";
const URL_SELF="/PagamentiWeb/api";

export const PATH_INIT=URL+"/rs/initLight"
export const PATH_INFO_USER=URL+"/infouser"                                
export const PATH_PAGAMENTO=URL+"/rs/homepagamento"
export const PATH_MENU_PRINCIPALI=URL+"/rs/menu"
export const PATH_PORTALE="/PortaleWeb"

//ANAGRAFICA

export const info_iva='http://127.0.0.1:3000/datiIdentificativi';
//export const info_iva='/moss/sign-oss/get-reg';
//export const invioRichiesta='/moss/sign-oss/add-reg';

//LABEL
export const UTENTE_CONNESSO="Utente connesso"

//COOKIE
export const X_APPL="x-appl"